var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 17.5C3.33301 17.9602 3.7061 18.3333 4.16634 18.3333C4.62658 18.3333 4.99967 17.9602 4.99967 17.5V13.8805L16.1154 9.06363C17.1194 8.62854 17.1194 7.20479 16.1154 6.76973L5.08002 1.98772C4.25462 1.63005 3.33301 2.23511 3.33301 3.13467V17.5ZM4.99967 3.76933L14.5705 7.91667L4.99967 12.064V3.76933Z",
    fill: "#4E5258"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandera);
export default __webpack_public_path__ + "static/media/bandera.8d9d3cba52d92cb6c80d1707050035fa.svg";
export { ForwardRef as ReactComponent };